import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import ToggleButton from "@mui/material/ToggleButton";

const SFToggleButton = forwardRef(({ children, onClick, value, disabled, selected, ariaLabel, ...props }, ref) => {
  return (
    <ToggleButton
      ref={ref}
      onClick={onClick}
      value={value}
      disabled={disabled}
      selected={selected}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </ToggleButton>
  );
});

SFToggleButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  value: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SFToggleButton;
